import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var Content = /*#__PURE__*/_createClass(function Content() {
  _classCallCheck(this, Content);

  this.value = '';
  this.value = '';
});